export default __webpack_public_path__ + "static/media/Abril_Cortés_AHV_In_Moms_We_Trust.304fec18.jpg";